<template>
    <div  class="unauthorized-img">
        <div>
            <div :class="{'no-detail': unauthorizeType == '404'}"></div>
            <span>{{ unauthorizeType == '404' ? '该知识内容已删除' : '无权限内可查看的知识内容'}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name:'unauthorize',
        props:['unauthorizeType'],
        data () {
            return {}
        },
        mounted () {},
        methods: {
        },
        watch: {
        }
    }
</script>

<style lang="scss" scoped>
    .unauthorized-img{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        pointer-events: none;
        &>div{
            transform: translateY(-30%);
            &>div{
                width: j(640);
                height: j(446);
                background: url('../../../static/images/403.png') no-repeat;
                background-size: contain;
            }
            &>span{
                display: block;
                text-align: center;
                font-size:j(32);
                font-weight:400;
                color:rgba(155,157,169,1);
                line-height:j(45);
            }
        }
        .no-detail{
            background-image: url('../../../static/images/404.png');
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/404/403.vue